webpackJsonp([7],{

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(60);



var detailLayout = function detailLayout() {
	return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 67));
};
var listLayout = function listLayout() {
	return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 69));
};
var recentLayout = function recentLayout() {
	return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 70));
};
var addRutto = function addRutto() {
	return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 65));
};
var info = function info() {
	return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 68));
};
var cookieInfo = function cookieInfo() {
	return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 66));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		name: 'Migliori rutti',
		component: listLayout
	}, {
		path: '/ruttirecenti',
		name: 'Rutti recenti',
		component: recentLayout
	}, {
		path: '/detail/:videoID',
		name: 'Video rutto',
		component: detailLayout,
		props: true
	}, {
		path: '/aggiungirutto',
		name: 'Aggiungi Rutto',
		component: addRutto
	}, {
		path: '/info',
		name: 'info',
		component: info
	}, {
		path: '/cookie-policy',
		name: 'cookie-policy',
		component: cookieInfo
	}]
}));

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(58),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_styleLoaders__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_styleLoaders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_styleLoaders__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mb = "";

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',
	components: {
		menuGdr: __WEBPACK_IMPORTED_MODULE_0__components_menu___default.a,
		styleLoaders: __WEBPACK_IMPORTED_MODULE_1__components_styleLoaders___default.a
	},
	props: {
		menuOpened: {
			default: false
		}
	},
	data: function data() {
		return {
			menuOpenedA: false,
			cookieOk: false
		};
	},

	computed: {
		online: function online() {
			if (navigator.onLine) {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		openMenu: function openMenu() {
			if (this.menuOpened) {
				this.$root.closeMenu();
			} else {
				this.$root.openMenu();
			}
			// this.$root.menuOpened = !this.$root.menuOpened;
		},
		closeMenu: function closeMenu() {
			// this.$root.menuOpened = false;
		},
		okCookie: function okCookie() {
			this.cookieOk = true;
			this.$setItem("cookieOk", true, function () {
				console.log("cookie accepted");
			});
			return this.cookieOk;
		},
		checkCookieCheck: function checkCookieCheck() {
			var obj = this;
			this.$getItem("cookieOk", function (err, data) {
				if (err) {
					obj.cookieOk = false;
					return;
				}
				obj.cookieOk = data;
				return;
			});
		}
	},
	mounted: function mounted() {
		this.checkCookieCheck();
		// alert("mounted started");
	}
});

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'listLayout',
	/*
 data () {
 	return {
 		opened:false
 	}
 },
 */
	props: {
		open: {
			default: false
		}
	},
	computed: {
		menuStyle: function menuStyle() {
			if (this.open) {
				return "menu opened";
			}
			return "menu";
		},
		sfondoStyle: function sfondoStyle() {
			if (this.open) {
				return "menuSfondo opened";
			}
			return "menuSfondo";
		}
	},
	methods: {
		openMenu: function openMenu() {
			if (this.opened) {
				this.open = false;
			} else {
				this.open = true;
			}
		},
		closeMenu: function closeMenu() {
			// this.open = false;
			this.$root.closeMenu();
		}
	}
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'styleLoaders',
	data: function data() {
		return {
			videos: []
		};
	},

	beforeDestroy: function beforeDestroy() {
		if (this.$root && this.$root.closeMenu) {
			this.$root.closeMenu();
		}
	}
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_social_sharing__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_social_sharing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_social_sharing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_localforage__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_localforage__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




// import firebase from 'firebase'


// import 'firebase/auth'




// import videoplayer from './components/videoPlayer'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_localforage___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_social_sharing___default.a);
// const firebase = () => import('firebase/app');
// const firebasedb = () => import('firebase/database')

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.performance = true;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.devtools = true;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuefire___default.a);

var firebaseApp = __WEBPACK_IMPORTED_MODULE_4_firebase_app__["a" /* default */].initializeApp({
	apiKey: "AIzaSyAS9UQkwOa_qtDXDvJ2YDaG1ccok7JGfKs",
	authDomain: "garadirutti1.firebaseapp.com",
	databaseURL: "https://garadirutti1.firebaseio.com",
	projectId: "garadirutti1",
	storageBucket: "garadirutti1.appspot.com",
	messagingSenderId: "915819367365"
});

// var apiUrl = "https://us-central1-garadirutti1.cloudfunctions.net/api/";

var apiUrl = "./api/";

// window.firebaseApp = firebaseApp;

// console.log("typeof firebaseApp.database", typeof firebaseApp.database);

var db = firebaseApp.database();

/* eslint-disable no-new */
var GdRbase = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	template: '<div><App :menuOpened="menuOpened"/></div>',
	data: {
		votes: 0,
		videoID: '',
		recentN: 5,
		bestN: 5,
		vote_ready: false,
		upload_ready: false,
		menuOpened: false
	},
	components: {
		App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
		// videoplayer
	},
	firebase: {
		anArray: db.ref('videos').orderByChild("votes").limitToLast(100),
		mostRecent: db.ref('videos').orderByChild("date").limitToLast(100)
	},
	methods: {
		subVotesForVideo: function subVotesForVideo(videoID) {
			// alert(videoID);
			var ref = db.ref("videos/" + videoID + "/votes");

			ref.on("value", function (dataSnapshot) {
				// this.votes = dataSnapshot.val()
				if (dataSnapshot.val() !== null) {
					this.votes = dataSnapshot.val();
				}
				// alert("hei")
				// alert(dataSnapshot);
			}, function () {}, this);
			/*
   ref.once("value")
   .then( (dataSnapshot) => {
   	this.votes = dataSnapshot.val()
   	// alert(dataSnapshot);
   })
   */
		},
		unsubVotesForVideo: function unsubVotesForVideo(videoID) {
			db.ref("videos/" + videoID + "/votes").off("value");
			this.votes = 0;
			console.log('unsubscribed');
		},
		openMenu: function openMenu() {
			this.menuOpened = true;
		},
		closeMenu: function closeMenu() {
			this.menuOpened = false;
		},
		voteUp: function voteUp(videoID) {
			if (videoID) {
				__WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(apiUrl + "voteUp", {
					videoID: videoID
				}).then(function (res) {
					console.log(res);
				}).catch(function (error) {
					console.log(error);
				});
			}
		},
		voteDown: function voteDown(videoID) {
			__WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(apiUrl + "voteDown", {
				videoID: videoID
			}).then(function (res) {
				console.log(res);
			}).catch(function (error) {
				console.log(error);
			});
		},
		addVideo: function addVideo(url) {
			__WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(apiUrl + "add", {
				url: url
			}).then(function (res) {
				console.log(res);
			}).catch(function (error) {
				console.log(error);
			});
		}
		/*
  saveToCookie: function(cookieName, values){
  	setCookie(cookieName, values, 365);
  },
  getFromCookie: function(cookieName){
  	getCookie(cookieName);
  },
  
  saveToLocal:function(key, value){
  	this.$setItem(key, value, function(){
  		console.log("saved")
  	});
  },
  getFromLocal:function(key){
  	}
  */
	}
});

/*
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
*/

window.addEventListener('offline', function (e) {
	console.log('offline');
});

window.addEventListener('online', function (e) {
	console.log('online');
});

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(57),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(59),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 57:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    class: _vm.sfondoStyle,
    on: {
      "click": _vm.closeMenu
    }
  }), _vm._v(" "), _c('nav', {
    class: _vm.menuStyle
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n\t\t\t\t\tRutti Migliori\n\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ruttirecenti"
    }
  }, [_vm._v("\n\t\t\t\t\tRutti Recenti\n\t\t\t\t")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/aggiungirutto"
    }
  }, [_vm._v("\n\t\t\t\t\tAggiungi un rutto\n\t\t\t\t")])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/info"
    }
  }, [_vm._v("\n\t\t\t\t\tMaggiori informazioni\n\t\t\t\t")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/cookie-policy"
    }
  }, [_vm._v("\n\t\t\t\t\tCookie Policy\n\t\t\t\t")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('hr')])
}]}

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('style-loaders'), _vm._v(" "), _c('header', [_c('span', [_c('button', {
    staticClass: "menuButton",
    attrs: {
      "aria-label": "apri menu"
    },
    on: {
      "click": _vm.openMenu
    }
  }, [_c('i', {
    staticClass: "gdr-icon gdr-icon-bars"
  }), _c('span', {
    staticStyle: {
      "display": "none !important"
    }
  }, [_vm._v("menu")])]), _vm._v("\n\t\t\tGara di rutti\n\t\t")])]), _vm._v(" "), _c('main', [_c('menu-gdr', {
    attrs: {
      "open": _vm.menuOpened
    }
  }), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), (!_vm.cookieOk) ? _c('div', {
    staticClass: "cookie-panel"
  }, [_vm._v("\n\t\tquesto sito usa cookie\n\t\t"), _c('router-link', {
    attrs: {
      "to": "/cookie-policy"
    }
  }, [_vm._v("\n\t\t\tCookie Policy\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "btn-cookie-cont"
  }, [_c('button', {
    staticClass: "btn-cookie",
    on: {
      "click": _vm.okCookie
    }
  }, [_vm._v("Accetto")])])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "styleLoaders"
  })
},staticRenderFns: []}

/***/ })

},[46]);


// WEBPACK FOOTER //
// static/js/app.e5b8b4d25680cefe0f24.js